

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { EmployeeSetup } from "../../components/EmployeeSetup";


export const EmployeeSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Employee Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      // breadcrumbLinks={[
      //   { text: "Employee", navigateTo: "/employee/list" }
      // ]}
      mainContents={<EmployeeSetup />}
    />
  );
};
